import React from "react";

const JQuery_Editor = () => {
  return (
    <div>
      <h1>JQuery_Editor</h1>
      <p>Placeholder component for: "JQuery_Editor"</p>
    </div>
  );
};

export default JQuery_Editor;
